import { Button, Col, Form, Input, InputNumber, Modal, Row, Tag } from "antd";
import { useEffect, useState } from "react";
import GetCompanyInfo from "../../functions/merchant/getCompanyInfo";
import AddVatMerchant from "../../functions/merchant/addVatMerchant";

import { useLoading } from "../../context/loadingContext";
import VatDistrictSelect from "../select/vatDistrictSelect";
import GetVatMerchantById from "../../functions/merchant/getVatMerchantById";
import UpdateVatMerchant from "../../functions/merchant/updateVatMerchant";
import { bg_button } from "constant/css";
import BankCodeSelect from "components/select/bankCodeSelect";
import IBANCheck from "functions/validation/IBANCheck";
import { getMerchantId } from "service/storage";
import {
  addVatMerchantExtraAccount,
  setVatMerchantExtraAccountStatus,
} from "../../functions/merchant/vatMerchantAccount";

const MerchantAddEdit = ({ open, close, vatMerchantId, refresh }) => {
  const [form] = Form.useForm();
  const [companyName, setCompanyName] = useState(null);
  const merchantId = getMerchantId();
  const register = Form.useWatch("register", form);
  const bankCode = Form.useWatch("bankCode", form);
  const accountNumber = Form.useWatch("accountNumber", form);
  const { showLoading, hideLoading, loading } = useLoading();
  const [fetching, setFetching] = useState(true);
  const [accountName, setAccountName] = useState(null);
  const [extraAccounts, setExtraAccounts] = useState([]);
  const [extraAccount, setExtraAccount] = useState("");
  const [extraBank, setExtraBank] = useState(null);
  const handleSubmit = async (values) => {
    if (vatMerchantId) return updateMerchant(values);
    showLoading();
    const response = await AddVatMerchant(values, merchantId);
    if (response) {
      refresh();
      close();
    }
    hideLoading();
  };
  const updateMerchant = async (values) => {
    showLoading();
    const response = await UpdateVatMerchant(values, merchantId, vatMerchantId);
    if (response) {
      refresh();
      close();
    }
    return hideLoading();
  };
  useEffect(() => {
    if (vatMerchantId) {
      fetchVatMerchant();
    } else setFetching(false);
  }, []);
  const fetchVatMerchant = async () => {
    setFetching(true);
    showLoading();
    const response = await GetVatMerchantById(merchantId, vatMerchantId);
    if (response) {
      const { accounts, ...fields } = response;
      form.setFieldsValue(fields);
      setExtraAccounts(Array.isArray(accounts) ? accounts : []);
    }
    hideLoading();
    setFetching(false);
  };
  useEffect(() => {
    if (
      (register && register.length === 7) ||
      (register && register.length === 10)
    ) {
      fetchCompany(register);
    } else setCompanyName(null);
  }, [register]);

  useEffect(() => {
    if (bankCode && accountNumber && String(accountNumber).length >= 9)
      fetchAccountInfo(bankCode, accountNumber);
  }, [bankCode, accountNumber]);
  const fetchAccountInfo = async (bankCode, accountNumber) => {
    showLoading();
    const response = await IBANCheck(accountNumber, bankCode);
    console.log("IBANCheck response:", response);
    if (response && response.data && response.data.name)
      setAccountName(response.data.name);
    else setAccountName(null);
    hideLoading();
  };
  const reloadExtraAccounts = async () => {
    const response = await GetVatMerchantById(merchantId, vatMerchantId);
    setExtraAccounts(Array.isArray(response?.accounts) ? response.accounts : []);
  };
  const addExtraAccount = async () => {
    showLoading();
    const response = await addVatMerchantExtraAccount(merchantId, vatMerchantId, {
      accountNumber: extraAccount,
      bankCode: extraBank,
    });
    if (response?.success) {
      setExtraAccount("");
      await reloadExtraAccounts();
    }
    hideLoading();
  };
  const toggleExtraAccount = async (row) => {
    showLoading();
    const response = await setVatMerchantExtraAccountStatus(
      merchantId,
      vatMerchantId,
      row.id,
      row.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
    );
    if (response?.success) await reloadExtraAccounts();
    hideLoading();
  };
  const fetchCompany = async (register) => {
    const companyInfo = await GetCompanyInfo(register);
    if (companyInfo && companyInfo.name) {
      setCompanyName(companyInfo.name);
      // Шинэ бүртгэлд л автоматаар татварын төрөл тохируулна.
      // Edit үед DB-д хадгалсан taxType-ийг дарахгүй.
      if (!vatMerchantId) {
        form.setFieldValue(
          "taxType",
          companyInfo.vatpayer ? "VAT_ABLE" : "VAT_FREE"
        );
      }
    } else setCompanyName(null);
  };
  return (
    <Modal
      title={`Дэд мерчант ${merchantId ? "засварлах" : "бүртгэх"}`}
      open={open}
      onCancel={close}
      footer={null}
    >
      <Form
        form={form}
        style={{ marginTop: 30 }}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row gutter={30} style={{ width: "100%" }}>
          <Col span={14}>
            <Form.Item
              label="Байгууллагын нэр"
              name="name"
              rules={[{ required: true, message: "Please input the name!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label="Регистр"
              name="register"
              rules={[
                { required: true, message: "Please input the register!" },
                {
                  pattern: /^(?:\d{7}|[А-ЯӨҮЁ]{2}\d{8})$/,
                  message: "Register must be 7 digits or 10 characters!",
                },
              ]}
            >
              <Input
                suffix={
                  <span className="text-xs text-gray-400">{companyName}</span>
                }
              />
            </Form.Item>
          </Col>
          <Col span={14}>
            <Form.Item
              label="Үйлчилгээний нэр"
              name="serviceName"
              rules={[
                { required: true, message: "Please input the service name!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item
              label="Татвар төлөгч"
              name="taxType"
              rules={[
                { required: true, message: "Please input the VAT type!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            {!fetching && (
              <Form.Item
                label="НӨАТ-н дүүрэг"
                name="vatDistrictCode"
                rules={[
                  {
                    required: true,
                    message: "Please input the vatDistrictCode!",
                  },
                ]}
              >
                {!loading && <VatDistrictSelect />}
              </Form.Item>
            )}
          </Col>
          <Col span={8}>
            <Form.Item
              label="Бүтээгдэхүүний код"
              name="taxProductCode"
              rules={[
                { required: true, message: "Please input the taxProductCode!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Үйлчилгээний код"
              name="serviceCode"
              rules={[
                { required: true, message: "Please input the service code!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Шимтгэлийн хувь"
              name="feePercent"
              rules={[
                { required: true, message: "Please input the taxProductCode!" },
              ]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              label="Үндсэн данс"
              name="accountNumber"
              rules={[
                { required: true, message: "Please input the accountNumber!" },
              ]}
            >
              <Input
                maxLength={20}
                suffix={
                  <span className="text-xs text-gray-400">{accountName}</span>
                }
                placeholder="Дансны дугаар"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Банк"
              name="bankCode"
              rules={[{ required: true, message: "Please choose bank!" }]}
            >
              <BankCodeSelect />
            </Form.Item>
          </Col>
          {vatMerchantId && (
            <Col span={24}>
              <div className="text-sm font-medium mb-2">Нэмэлт данс</div>
              {extraAccounts.map((row) => (
                <div
                  key={row.id}
                  className="flex items-center justify-between gap-2 mb-1 text-xs"
                >
                  <span>
                    {row.accountNumber}
                    {row.bankCode ? ` · ${row.bankCode}` : ""}
                  </span>
                  <span className="flex items-center gap-2">
                    <Tag color={row.status === "ACTIVE" ? "cyan" : "default"}>
                      {row.status === "ACTIVE" ? "Идэвхтэй" : "Ашиглахаа больсон"}
                    </Tag>
                    <Button
                      size="small"
                      htmlType="button"
                      onClick={() => toggleExtraAccount(row)}
                    >
                      {row.status === "ACTIVE" ? "Болих" : "Идэвхжүүлэх"}
                    </Button>
                  </span>
                </div>
              ))}
              <div className="flex gap-2 mt-2">
                <Input
                  value={extraAccount}
                  maxLength={20}
                  placeholder="Нэмэлт данс"
                  onChange={(event) => setExtraAccount(event.target.value)}
                />
                <BankCodeSelect value={extraBank} onChange={setExtraBank} />
                <Button
                  htmlType="button"
                  onClick={addExtraAccount}
                  disabled={!extraAccount || !extraBank}
                >
                  Данс нэмэх
                </Button>
              </div>
            </Col>
          )}

          <Col span={24} style={{ textAlign: "center" }}>
            <Form.Item className="centerItem">
              <Button
                className={`${bg_button}`}
                disabled={!companyName || !accountName}
                type="primary"
                htmlType="submit"
              >
                Бүртгэх
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default MerchantAddEdit;
